export default __webpack_public_path__ + "static/media/FAQPageLocation.61069c71.jpg";